var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 94,
    viewBox: "0 0 128 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6188 35.5945L99.6186 36.0737L100.097 36.0942C115.34 36.7478 127.5 49.3417 127.5 64.7838C127.5 80.6444 114.673 93.5 98.8515 93.5H29.1485C13.3275 93.5 0.5 80.6444 0.5 64.7838C0.5 48.9232 13.3275 36.0676 29.1485 36.0676H29.6485V35.5676C29.6485 16.1992 45.313 0.5 64.6337 0.5C83.9543 0.5 99.6187 16.1991 99.6188 35.5674C99.6188 35.5674 99.6188 35.5675 99.6188 35.5676L99.6188 35.5945Z",
    stroke: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.431 72.4375L63.9374 48.8392L81.444 72.4375H69.8891H69.3891V72.9375V93.5H58.5767V72.9375V72.4375H58.0767H46.431Z",
    stroke: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.08fd43ef058e87719dae38f3e5027c5c.svg";
export { ForwardRef as ReactComponent };